import { createSelector } from '@ngrx/store';

import { JobsBriefSelectors } from '../jobs/jobs-brief.store';
import { JobItemsSelectors } from '../jobs/jobs.store';
import { JobsIdMap } from './../../types';

const activeItemsAndArchivedBrief = createSelector(
  JobItemsSelectors.active,
  JobsBriefSelectors.archived,
  (active, archived) => [...active, ...archived],
);

const activeItemsAndArchivedBriefIdMap = createSelector(activeItemsAndArchivedBrief, offers =>
  offers.reduce((acc, offer) => {
    acc[offer.id] = offer;
    return acc;
  }, <JobsIdMap>{}),
);

const selectors = {
  activeItemsAndArchivedBrief,
  activeItemsAndArchivedBriefIdMap,
};

export { selectors as JobsCombinedSelectors };
